//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
export default {
  name: 'SettingPage',
  extends: vComponent,
  data () {
    return {
      inputVal: '',
      columns: [], // 欄位宣告
      items: [
        'red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue',
        'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber',
        'orange', 'deep-orange', 'brown', 'grey', 'blue-grey'
      ],
      pagination: {
        page: 1, // 目前第幾頁
        rowsPerPage: 50 // 每頁幾筆
      }
    }
  },
  computed: {
    ...mapGetters([
      'stock_no',
      'theme'
    ]),
    bgColor () {
      return `bg-${this.theme}-5`
    },
    textColor () {
      return `text-white`
    }
  },
  created () {
    this.inputVal = this.stock_no !== undefined && this.stock_no !== null ? this.stock_no : ''
  },
  mounted () {
  },
  methods: {
    clickBtn (themeColor) {
      this.dispatch('SetTheme', themeColor)
    },
    alert (title = '', info) {
      this.$q.dialog({
        title: title,
        message: info
      }).onOk(() => {
        // console.log('OK')
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }
  }
}
